import * as React from 'react';
import CheckmarkOutlined from './checkmark-outlined';
import CheckmarkFilled from './checkmark-filled';
import type { IconCombinedProps } from './types';
const CheckmarkCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <CheckmarkFilled ref={ref} {...rest} />;
  }
  return <CheckmarkOutlined ref={ref} {...rest} />;
});
export default CheckmarkCombined;